import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
const PACK_IMG = 'https://cdn.magicpatterns.com/uploads/trre3bBDaX5DYvw9XuufCR/Captura_de_pantalla_2026-06-19_a_la(s)_3.41.15_p._m..png';
export function ProductReveal() {
  return <section className="border-y border-white/[0.16] bg-espresso py-[88px]" data-id="element-100">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-101">
        <div className="grid grid-cols-1 items-center gap-[50px] lg:grid-cols-[1fr_0.9fr]" data-id="element-102">
          {/* Texto */}
          <Reveal data-id="element-103">
            <Eyebrow data-id="element-104">EL PRODUCTO</Eyebrow>
            <h2 className="max-w-[480px] text-[clamp(26px,4vw,40px)] leading-[1.1] text-white" data-id="element-105">
              YA EXISTE. TODAVÍA NO TE LO MOSTRAMOS.
            </h2>
            <p className="mt-5 max-w-[460px] text-[clamp(15px,1.6vw,17px)] font-medium text-white/75" data-id="element-106">
              El envase está listo. El sabor, la fórmula y todo lo demás se
              revelan el día del lanzamiento — y la lista de espera lo ve
              primero. No te lo mostramos antes por una razón: lo que importa no
              se copia mirando una foto.
            </p>
            <p className="mt-4 font-mono text-[13px] uppercase tracking-[1.5px] text-camel-light" data-id="element-107">
              La lista lo ve primero.
            </p>
          </Reveal>

          {/* Doypack censurado */}
          <Reveal className="flex justify-center" data-id="element-108">
            <div className="relative aspect-[3/4] w-full max-w-[340px] overflow-hidden rounded-2xl border border-camel/30" data-id="element-109">
              {/* Silueta del envase, fuertemente oscurecida (no legible) */}
              <img src={PACK_IMG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-110 object-cover opacity-40 blur-2xl brightness-[0.25]" data-id="element-110" />
              <div className="absolute inset-0 bg-espresso-2/90" data-id="element-111" />

              {/* Faja diagonal "CONFIDENCIAL" */}
              <div className="absolute left-[-60px] top-7 w-[240px] -rotate-45 bg-camel py-1.5 text-center font-display text-[12px] tracking-[2px] text-espresso-2" data-id="element-112">
                CONFIDENCIAL
              </div>

              {/* "?" central */}
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-113">
                <span className="font-display text-[clamp(90px,18vw,150px)] leading-none text-camel" aria-hidden="true" data-id="element-114">
                  ?
                </span>
                <span className="mt-3 border border-white/20 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[2px] text-white/70" data-id="element-115">
                  Sin revelar
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}